import { QuizQuestion } from "../../../common/components/quiz/useQuiz";

export const securitySettingsQuizQuestions: QuizQuestion[] = [
  {
    id: "security-q1",
    prompt: "What formats are accepted when uploading a profile picture?",
    options: [
      { id: "a", label: "GIF and SVG only" },
      { id: "b", label: "JPG, JPEG, and PNG only" },
      { id: "c", label: "All image formats" },
      { id: "d", label: "PDF and PNG" },
    ],
    correctOptionId: "b",
    explanation:
      "Only JPG, JPEG, and PNG files are accepted for profile pictures. You can also crop the image after uploading.",
  },
  {
    id: "security-q2",
    prompt: "What is required to change your email address?",
    options: [
      { id: "a", label: "No verification is needed" },
      {
        id: "b",
        label: "An OTP code sent to your new email address to confirm the change",
      },
      { id: "c", label: "A call to support" },
      { id: "d", label: "Approval from a Super Admin" },
    ],
    correctOptionId: "b",
    explanation:
      "When changing your email, an OTP code is sent to your new email address. You must enter this code to verify and complete the update.",
  },
  {
    id: "security-q3",
    prompt: "What does enabling Two-Factor Authentication (2FA) do?",
    options: [
      { id: "a", label: "Removes the need for a password" },
      {
        id: "b",
        label: "Adds an extra verification code step during login for improved account security",
      },
      { id: "c", label: "Logs you out of all sessions automatically" },
      { id: "d", label: "Locks your account" },
    ],
    correctOptionId: "b",
    explanation:
      "2FA adds a second layer of security by requiring a verification code alongside your password when you log in.",
  },
  {
    id: "security-q4",
    prompt: "Which fields are required when editing Personal Information?",
    options: [
      { id: "a", label: "Only your name" },
      { id: "b", label: "First name, last name, and birthdate" },
      { id: "c", label: "Email address and mobile number" },
      { id: "d", label: "Custom name and prefix" },
    ],
    correctOptionId: "b",
    explanation:
      "First name, last name, and birthdate are required fields when editing your personal information.",
  },
  {
    id: "security-q5",
    prompt: "What is the minimum password length requirement?",
    options: [
      { id: "a", label: "6 characters" },
      { id: "b", label: "10 characters" },
      { id: "c", label: "8 characters" },
      { id: "d", label: "12 characters" },
    ],
    correctOptionId: "c",
    explanation:
      "Passwords must be at least 8 characters long and include uppercase, lowercase, a number, and a special character.",
  },
];
